import React from 'react';
import { ReactComponent as Logo } from '../assets/Icons/logo.svg';
import { Link } from 'react-router-dom';
import { AppRoutesPaths } from '../routes/types';

export const Footer = () => {
  return (
    <footer className="px-6 py-10 sm:px-10 sm:py-12 bg-background-secondary text-white">
      <div className="max-w-screen-2xl mx-auto">
        <div className="max-w-7xl mx-auto flex justify-between flex-wrap gap-8">
          <div className="space-y-6">
            <Logo className="h-14 text-sm" />
          </div>
          <div className="space-y-6 text-sm font-semibold">
            <p>
              <Link
                to="https://frontiertech.edu/wp-content/uploads/2026/05/Catalog-Frontier-Institute-2026-04-30.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Catalog
              </Link>
            </p>
            <p>
              <Link
                to={'https://frontiertech.edu/requirements-policies/'}
                target="_blank"
                rel="noopener noreferrer"
              >
                Admissions
              </Link>
            </p>
          </div>
          <div className="space-y-6 text-sm font-semibold">
            <p>
              <Link
                to={'https://www.frontiertech.edu/accreditation-licensure'}
                target="_blank"
                rel="noopener noreferrer"
              >
                Accreditation
              </Link>
            </p>
            {/*<p>
              <Link
                to={'https://www.frontiertech.edu/mission-goals'}
                target="_blank"
                rel="noopener noreferrer"
              >
                Mission & History
              </Link>
            </p>*/}
            <p>
              <Link
                to={'https://www.frontiertech.edu/contact-us'}
                target="_blank"
                rel="noopener noreferrer"
              >
                Contact Us
              </Link>
            </p>
          </div>
          <div className="space-y-6 text-md font-semibold">
            <p>Connect</p>
            <div className="font-normal">
              <p>140 E Broadway Ave, #25</p>
              <p>Jackson, WY 83001</p>
            </div>
            <a href="tel:+13072642843" className="underline font-normal">
              +1 (307) 264-2843
            </a>
          </div>
        </div>
        <div className="border-t border-white/50 mt-10 pt-4 flex flex-col md:flex-row justify-between items-start md:items-center text-white/80 text-xs">
          <p>
            Accredited by the{' '}
            <span className="font-semibold text-white">
              Distance Education Accrediting Commission (DEAC)
            </span>
          </p>
          <p>
            Copyright © {new Date().getFullYear()} Frontier Institute of
            Technology &nbsp;|&nbsp;
            <Link
              to={'https://frontiertech.edu/privacy-policy/'}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary"
            >
              Privacy Policy
            </Link>
            &nbsp;|&nbsp;
            <Link
              to={'https://www.frontiertech.edu/terms-of-use'}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary"
            >
              Terms of Use
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
};
